
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { takeMixin } from "./takeMixin";
@Component({})
export default class Name extends mixins(takeMixin) {
  startTakePhoto() {
    console.log("触发拍摄");
    if (this.filming) {
      return;
    }
    this.imgData = [];
    this.filming = true;
    console.log("第一次拍摄");
    setTimeout(() => {
      // 第一次拍摄
      this.takePhoto().then(() => {
        console.log("第一次拍摄完成");
        // 第二次拍摄
        this.changeLight().then(() => {
          console.log("第二次拍摄");
          this.takePhoto().then(() => {
            // 第三次拍摄
            console.log("第二次拍摄完成");
            this.changeLight().then(() => {
              console.log("第三次拍摄");
              this.takePhoto().then(async () => {
                console.log("第三次拍摄完成");
                console.log("白光-OFF");
                const res = await window.electronMyAPI.changeLight("白光-OFF");
                if (res) {
                  console.log("返回值：" + res);
                  console.log("保存图片");
                  // 保存图片
                  const loading = this.$loading({
                    lock: true,
                    text: "图片上传中……",
                    spinner: "el-icon-loading",
                    customClass: "loadClass",
                    background: "rgba(255, 255, 255, 0.7)",
                  });
                  this.upload(this.imgData[0]).then(() => {
                    this.upload(this.imgData[1]).then(() => {
                      this.upload(this.imgData[2]);
                      loading.close();
                      // 这里是为了方便重新拍摄
                      console.log("保存成功");
                      console.log("白光-ON-100");
                      window.electronMyAPI.changeLight("白光-ON-100");
                      this.filming = false;
                    });
                  });
                }
              });
            });
          });
        });
      });
    }, 100);
  }
  private mounted() {
    // this.getCameraDevices();
  }
}
